import React from "react";
import ReactDOM from "react-dom";
import axios from "axios";

class AnnouncementBanner extends React.Component {
  constructor() {
    super();
    this.state = {
      announcements: [],
      expanded: false
    };
  }

  componentDidMount() {
    // Fetch all the announcement messages
    axios
      .get("/announcements.json")
      .then((res) => {
        this.setState({ announcements: res.data });
      })
      .catch(() => {
        // Some authenticated roles cannot access the announcements index.
        // The global banner is optional for those roles, so render it empty
        // instead of surfacing an unhandled promise rejection.
        this.setState({ announcements: [] });
      });
  }

  toggleExpanded = () => {
    this.setState((state) => ({ expanded: !state.expanded }));
  };

  setBackgroundColor(level) {
    switch (level) {
      case "Notification":
        return "has-background-light has-text-black";
      case "Warning":
        return "has-background-warning has-text-black";
      case "Danger":
        return "has-background-danger has-text-white";
      default:
        return "is-light";
    }
  }

  render() {
    const { announcements, expanded } = this.state;

    if (announcements.length === 0) return null;

    return (
      <section id="announcement-banner-component" aria-label="Active announcements">
        <button
          aria-controls="announcement-banner-list"
          aria-expanded={expanded}
          className="announcement-banner-summary"
          onClick={this.toggleExpanded}
          type="button"
        >
          <span className="fa fa-bullhorn" aria-hidden="true" />
          <span>
            {announcements.length} active{" "}
            {announcements.length === 1 ? "announcement" : "announcements"}
          </span>
          <span className="announcement-banner-summary__action">{expanded ? "Hide" : "View"}</span>
        </button>
        <div
          className={`announcement-banner-list ${expanded ? "is-expanded" : ""}`}
          id="announcement-banner-list"
        >
          {announcements.map((announcement) => (
            <div
              key={announcement.id}
              className={`announcement-item ${this.setBackgroundColor(announcement.level)}`}
            >
              <span className="announcement-icon fa fa-bullhorn" aria-hidden="true" />
              <span>{announcement.content}</span>
            </div>
          ))}
        </div>
      </section>
    );
  }
}

document.addEventListener("DOMContentLoaded", () => {
  const element = document.getElementById("annonucement-banner");

  if (element) {
    ReactDOM.render(<AnnouncementBanner />, element);
  }
});
